export default {
  name: 'itemsList',
  props: [
    'items',
    'title',
    'hintColumnName',
    'textNoneFound',
    'paginated',
    'totalPages',
    'sortTypes',
    'isLoadingItems',
    'isDisabledItems',
    'noItemsFoundText'
  ],
  data () {
    return {
      page: 1,
      search: '',
      isSearching: false,
      selectedSortType: 'asc'
    }
  },
  methods: {
    sortList (sort) {
      this.page = 1
      this.$emit('emit-sort-list', sort)
    },
    changePage (page) {
      this.$emit('emit-change-page', page)
    },
    filterList () {
      this.page = 1
      this.$emit('emit-filter-list', this.search)
    },
    clearFilter () {
      this.search = ''
      this.$emit('emit-filter-list', this.search)
    },
    selectItem (item) {
      this.$emit('emit-select-item', item)
    }
  }
}
